import { load } from '@ms/yammer-data/dist/domains/featureAccessInsights/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useFeatureAccessInsights, useFeatureAccessInsightsStatus } from './selectors';

type UseLoadFeatureAccessInsights = (props: { readonly selectedOnBehalfOfUserId?: string }) => void;
export const useLoadFeatureAccessInsights: UseLoadFeatureAccessInsights = ({ selectedOnBehalfOfUserId }) => {
  const dispatch = useDispatch();
  const featureAccessInsights = useFeatureAccessInsights();
  const status = useFeatureAccessInsightsStatus();

  useEffect(() => {
    const isFulfilledAndSameOnBehalfOfUserId =
      featureAccessInsights?.onBehalfOfUserId === selectedOnBehalfOfUserId && status === 'fulfilled';

    if (isFulfilledAndSameOnBehalfOfUserId || status === 'rejected') {
      return;
    }

    void dispatch(load({ onBehalfOfUserId: selectedOnBehalfOfUserId }));
  }, [dispatch, featureAccessInsights?.onBehalfOfUserId, selectedOnBehalfOfUserId, status]);
};
